import Button from "components/Elements/Button/Button";
import styles from "./styles.module.scss";
import { useContent } from "contexts/contentContext/contentContext";
import Image from "components/Elements/Image/Image";

const AnvilableFormComponent = ({ isPreventedDisplayForm }) => {
  const { getTextByKey } = useContent();
  return (
    <div className={`embed-dynamic-container ${styles.embedDynamicContainer}`}>
      <div className={styles.formContantContainer}>
        <Image name="disabled-form" ext="svg" />
        <h3>{getTextByKey("form-not-available")}</h3>
        {!isPreventedDisplayForm && (
          <p>{getTextByKey("form-not-available-description")}</p>
        )}
      </div>
      <Button disabled className={styles.formButton}>
        {getTextByKey("form-continue")}
      </Button>
    </div>
  );
};

export default AnvilableFormComponent;
